import React from 'react';
import { Button, Typography, TextField, Fade, Switch, FormControlLabel, Divider } from '@material-ui/core';
import { Playlist } from '../Playlist';
import { MainContext } from '../../context';
import { SaveToAccountModal } from '../CreatePlaylist/SaveToAccountModal';
import { TrackSearchList } from './TrackSearchList';
import { FinalPageFooter } from '../FinalPageFooter';
import { useStyles } from '../CreateByArtist/styles';
const Spotify = require('spotify-web-api-js');
const spotifyWebApi = new Spotify();

export const CreateBySong = () => {
  const [playlistSongs, setPlaylistSongs] = React.useState([]);
  const classes = useStyles();
  const [songSearchString, setSongSearchString] = React.useState('');
  const [tracksFromSongSearch, setTracksFromSongSearch] = React.useState([]);
  const [fullTrack, setFullTrack] = React.useState({ id: '' });
  const [trackSelected, setTrackSelected] = React.useState(false);
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [instrumental, setInstrumental] = React.useState(false);
  const { accessToken } = React.useContext(MainContext);

  React.useEffect(() => {
    if (accessToken) {
      spotifyWebApi.setAccessToken(accessToken);
    }
  }, []);

  React.useEffect(() => {
    spotifyWebApi.search(songSearchString, ['track']).then((res: any) => {
      setTracksFromSongSearch(res.tracks.items);
    });
  }, [songSearchString]);

  const handleSearchStringChange = (event: React.ChangeEvent<{ value: string }>) => {
    setSongSearchString(event.target.value);
  };
  const createPlaylist = () => {
    spotifyWebApi
      .getRecommendations({ seed_tracks: [fullTrack.id], target_instrumentalness: instrumental ? 1.0 : 0.2 })
      .then((res: any) => {
        setPlaylistSongs(res.tracks);
      });
    setShowPlaylist(true);
  };

  const handleTrackClicked = (track: any) => {
    setFullTrack(track);
    setSongSearchString(`${track.name} - ${track.artists[0].name}`);
    setTracksFromSongSearch([]);
    setTrackSelected(true);
  };

  const handleReset = () => {
    setFullTrack({ id: '' });
    setSongSearchString('');
    setTrackSelected(false);
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <div>
        <Typography variant="h3" style={{ color: 'white', margin: 15, fontStyle: 'italic' }}>
          Enter a song!
        </Typography>
        <TextField
          className="searchField"
          label="Enter Song"
          onChange={handleSearchStringChange}
          value={songSearchString}
        />
        <Button variant="outlined" className={classes.root} onClick={() => handleReset()}>
          Reset
        </Button>
      </div>

      {trackSelected || (
        <TrackSearchList
          handleTrackClicked={handleTrackClicked}
          songSearchString={songSearchString}
          tracksFromSongSearch={tracksFromSongSearch}
        />
      )}

      {trackSelected && (
        <div>
          <Button variant="contained" onClick={() => createPlaylist()} className={classes.button}>
            Create Playlist From Song
          </Button>
          <FormControlLabel
            style={{ color: 'white' }}
            control={
              <Switch
                color="primary"
                checked={instrumental}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setInstrumental(event.target.checked)}
                name="checkedA"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
              />
            }
            label="Instrumental only?"
            labelPlacement="top"
          />
        </div>
      )}

      {showPlaylist && (
        <div>
          <Divider />
          <div className="playlistContainer">
            <Playlist playlist={playlistSongs} show={showPlaylist} setShow={setShowPlaylist} />
            <SaveToAccountModal show={showModal} setShow={setShowModal} playlist={playlistSongs} />
          </div>
        </div>
      )}
      <FinalPageFooter forwardEnabled={showPlaylist} backwardLink="/createPlaylist" setShowModal={setShowModal} />
    </div>
  );
};
